<app-dialog-container
    [loading]="false"
    (closeEvent)="closeDialogFalse()"
>
    <div class="is-flex align-center justify-center break-newline has-text-centered">{{ data.text }}</div>
    <div class="level">
        <div
            *ngIf="data.falseButtonText"
            class="level-left"
        >
            <div class="level-item">
                <app-button
                    [buttonText]="data.falseButtonText"
                    (buttonClick)="closeDialogFalse()"
                    [type]="'stroked'"
                    [class]="'margin-top-75-em'"
                />
            </div>
        </div>
        <div [class]="data.centerTrueButton ? 'level-item' : 'level-right'">
            <div class="level-item">
                <app-button
                    [buttonText]="data.trueButtonText"
                    (buttonClick)="closeDialogTrue()"
                    [type]="'flat'"
                    [class]="'margin-top-75-em'"
                />
            </div>
        </div>
    </div>
</app-dialog-container>
